import 'normalize.css';
import '@assets/styles/bootstrap.css';
import '@models/store';
import { FocaProvider } from 'foca';
import { createRoot } from 'react-dom/client';
// import * as Sentry from '@sentry/react';
// import { config } from '@config';
import { RouterProvider, createHashRouter } from 'react-router-dom';
import { routerObjects } from 'src/routers/router';
import { RefreshProvider } from '@hooks/use-refresh';
import { registerSuiSnapWallet } from '@kunalabs-io/sui-snap-wallet';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import { SuiClientProvider, WalletProvider } from '@mysten/dapp-kit';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SuiClient } from '@mysten/sui/client';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { config } from '@config';

dayjs.extend(utc);
registerSuiSnapWallet();
dayjs.extend(LocalizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const queryClient = new QueryClient();

createRoot(document.querySelector('#root')!).render(
  <FocaProvider>
    <QueryClientProvider client={queryClient}>
      <SuiClientProvider
        defaultNetwork={config.sui_network}
        createClient={() => {
          return new SuiClient({
            url: config.fullnode,
          });
        }}
      >
        <WalletProvider preferredWallets={['msafe']} autoConnect={true}>
          <RefreshProvider>
            <RouterProvider router={createHashRouter(routerObjects)} />
          </RefreshProvider>
        </WalletProvider>
      </SuiClientProvider>
    </QueryClientProvider>
  </FocaProvider>,
);
